import { render, staticRenderFns } from "./Agroturismo.vue?vue&type=template&id=581ee428"
import script from "./Agroturismo.vue?vue&type=script&lang=js"
export * from "./Agroturismo.vue?vue&type=script&lang=js"
import style0 from "./Agroturismo.vue?vue&type=style&index=0&id=581ee428&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports